import InputError from "@/Components/InputError";
import TextArea from "@/Atoms/Input/TextArea";
import React, {FormEvent} from "react";
import useAjaxForm from "@/helpers/useAjaxForm";
import {relativeRoute} from "@/helpers/relativeRoute";
import useRecaptcha from "@/helpers/useRecaptcha";
import {usePage} from "@inertiajs/react";


const ContactForm = () => {

  const {verify} =  useRecaptcha('CONTACTFORM')

  const { data, setData, post, processing, success, setSuccess, errors } = useAjaxForm<
    {
      name: string
      email: string
      phone: string
      organisation_name: string
      message: string
      recaptcha: string
    }>();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {

    e.preventDefault();

    const recaptcha = await verify();

    await post(relativeRoute('contact-submit'), {
      extraData: {recaptcha},
    })

  };

  return <form className="max-w-3xl mx-auto" onSubmit={handleSubmit}>
    <fieldset disabled={processing}>

      {success ? (
        <div>
          <p>Het contactformulier is verzonden.</p>
          <button onClick={() => setSuccess(false)}>Opnieuw</button>
        </div>
      ) : (<><h2 className="text-center py-5">Vul het contactformulier in</h2>


        <div className="grid grid-cols-1  md:grid-cols-2 gap-6">
          <div>
            <label htmlFor="contact__name">Naam</label>
            <input
              type="text"
              value={data.name ?? ''}
              onChange={(e) => setData('name', e.target.value)}
              id="contact__name" placeholder="Naam"/>
            <InputError message={errors.name}/>
          </div>
          <div>
            <label htmlFor="contact__email">E-mail</label>
            <input
              type="text"
              value={data.email ?? ''}
              onChange={(e) => setData('email', e.target.value)}
              id="contact__email"
              placeholder="E-mail"/>
            <InputError message={errors.email}/>
          </div>
          <div>
            <label htmlFor="contact__phone">Telefoonnummer</label>
            <input
              type="text"
              value={data.phone ?? ''}
              onChange={(e) => setData('phone', e.target.value)}
              id="contact__phone"
              placeholder="Telefoonnummer"/>
            <InputError message={errors.phone}/>
          </div>
          <div>
            <label htmlFor="contact__company">Bedrijfsnaam</label>
            <input
              type="text"
              value={data.organisation_name ?? ''}
              onChange={(e) => setData('organisation_name', e.target.value)}
              id="contact__company"
              placeholder="Bedrijfsnaam"/>
            <InputError message={errors.organisation_name}/>
          </div>
        </div>
        <div className="py-6">
          <label htmlFor="contact__message">Opmerking</label>
          <TextArea
            value={data.message ?? ''}
            onChange={(e) => setData('message', e.target.value)}
            id="contact__message" placeholder="Vul hier je opmerking in"
            maxLength={10000}
          />
          <InputError message={errors.message}/>

        </div>

        <button type="submit">Versturen</button>
        <InputError message={errors.recaptcha}/>

      </>)}
    </fieldset>
  </form>
}

export default ContactForm
